import { Component, OnInit, OnDestroy } from "@angular/core";
import { Partner } from "@edp-models/edp-partner.model";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Store, select } from "@ngrx/store";
import { IAppState } from "@edp-store/state/app.state";
import { getPartnerInfo } from "@edp-store/selectors/contract.selectors";
import { PartnerInfo } from "@edp-models/edp-partner-info.model";

@Component({
    selector: "edp-widget-partners",
    templateUrl: "./edp-widget-partners.component.html",
    styleUrls: ["./edp-widget-partners.component.scss"],
})
export class EdpWidgetPartnersComponent implements OnInit, OnDestroy {
    public partner: Partner;
    public labelDescription: string;
    public labelDescriptionMobile: string;
    private unsubscribe = new Subject();

    constructor(
        private store: Store<IAppState>
    ) {}

    public ngOnInit() {
        this.store.pipe(
            takeUntil(this.unsubscribe),
            select(getPartnerInfo)
        ).subscribe((partnerInfo: PartnerInfo) => {
            if (partnerInfo && partnerInfo.newPartners && partnerInfo.newPartners.length > 0) {
                this.partner = partnerInfo.newPartners[0];
                this.labelDescription = "pt.edp.edponline.widget.benefits.new." + this.partner.name.toLowerCase().replace(/\s/g, "");
                this.labelDescriptionMobile = "pt.edp.edponline.widget.benefits.mobile.new."
                    + this.partner.name.toLowerCase().replace(/\s/g, "");
            }
        });
    }

    public ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
